import { createSlice } from "@reduxjs/toolkit";

const initialCloseState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  meta: { total: 0 },
  links: null,
  lastError: null,
  closeForEdit: undefined,
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const closeSlice = createSlice({
  name: "close",
  initialState: initialCloseState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    closeFetched: (state, action) => {
      const { entities, meta, links } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.meta = meta;
      state.links = links;
    },
    closeAllFetched: (state, action) => {
      const { count, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = count;
    },
    closeCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.close.push(action.payload.close);
    },
    closeDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.close.filter(el => el.close_id !== action.payload.id);
    },
    getClose: (state, action) => {
      state.actionsLoading = false;
      state.closeForEdit = action.payload.closeForEdit;
      state.error = null;
    },
    // updateProduct
    closeUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities.close = state.entities.close.map(entity => {
        if (entity.close_id === action.payload.close.close_id) {
          return action.payload.close;
        }
        return entity;
      });
    },
  },
});
